import { LOADING } from "../actionType/commonType";
import { EMAIL_CONFIGURATION } from "../actionType/emailSetupType";

const initialState = {
  emailConfiguration: null,
  loading: false,
};

const emailSetupReducer = (state = initialState, action)=>{
    const { type, payload } = action;
    switch (type) {
      case EMAIL_CONFIGURATION:
        return { ...state, emailConfiguration: payload };
      case LOADING:
        return { ...state, loading: payload };
      default:
        return state;
    }
}

export default emailSetupReducer;
